export const Segments = [
  {
    value: 6,
    key: 'SCTE Program Start',
    label: 'SCTEProgramStart',
    isShow: true
  },
  {
    value: 1,
    key: 'Reference Media',
    label: 'ReferenceMedia',
    isShow: true
  },
  {
    value: 2,
    key: 'SCTE(Splice)',
    label: 'SCTESplice',
    isShow: true
  },
  {
    value: 11,
    key: 'SCTE (Time Signal Auto Stop)',
    label: 'TimeSignalAuto',
    isShow: true
  },
  // {
  //   value: 12,
  //   key: 'SCTE (Time Signal)',
  //   label: 'TimeSignalFree'
  // },
  // {
  //     value: 3,
  //     key: 'GFX'
  // },
  {
    value: 4,
    key: 'Underplay',
    label: 'Underplay',
    isShow: true
  },
  {
    value: 5,
    key: 'Promo',
    label: 'Promo',
    isShow: true
  },
  {
    value: 15,
    key: 'Live',
    label: 'Live',
    isShow: true
  },
  {
    value: 10,
    key: 'Media',
    label: 'Media',
    isShow: true
  },
  // {
  //     value: 8,
  //     key: 'Slate'
  // },
  {
    value: 9,
    key: 'Black',
    label: 'Black',
    isShow: true
  },
  {
    value: 13,
    key: 'Secondary',
    label: 'Secondary',
    isShow: true
  },
  {
    value: 7,
    key: 'SCTE Program End',
    label: 'SCTEProgramEnd',
    isShow: true
  },
  {
    value: 14,
    key: 'SCTE (Time Signal Multi Auto Stop)',
    label: 'TimeSignalMultiAuto',
    isShow: true
  }
]
export const LogoConfig = [
  {
    value: 'Logo',
    label: 'Logo'
  },
  {
    value: 'Crawl',
    label: 'Crawl'
  },
  {
    value: 'SCTE',
    label: 'SCTE'
  }
]
export const ScteType = [
  {
    value: 'Scte only',
    label: 'SCTEonly',
    file: false,
    In: false,
    Out: false
  },
  {
    value: 'Underplay clip',
    label: 'UnderplayClip',
    file: false,
    In: false,
    Out: false
  },
  {
    value: 'Underplay Block',
    label: 'UnderplayBlock',
    file: false,
    In: false,
    Out: false
  }
]
export const UnderplayType = [
  {
    value: 'Ad Underplay',
    label: 'Underplay',
    file: true,
    In: true,
    Out: true
  },
  {
    value: 'Promo Media',
    label: 'Promo Media',
    file: true,
    In: true,
    Out: true
  },
  {
    value: 'Slate',
    label: 'Slate',
    file: true,
    In: true,
    Out: true
  }
]
export const SourceClassifyConfig = [
  {
    name: 'lang.ext',
    type: 'ext',
    switch: true
  },
  {
    name: 'lang.pack',
    type: 'pack',
    switch: false
  },
  {
    name: 'lang.anywhere',
    type: 'anywhere',
    switch: false
  },
  {
    name: 'lang.gridSDI',
    type: 'gridSDI',
    switch: false
  },
  {
    name: 'lang.gridPack',
    type: 'gridPack',
    switch: false
  },
  {
    name: 'lang.RTMPPush',
    type: 'rtmp',
    switch: false
  },
  {
    name: 'lang.Producer',
    type: 'producer',
    switch: false
  }
]
export const InquireSourceParam = {
  ext: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['ext'],
    total: 0
  },
  pack: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['pack'],
    total: 0
  },
  anywhere: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['anywhere'],
    total: 0
  },
  gridSDI: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['gridsdi'],
    total: 0
  },
  gridPack: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['gridpack'],
    total: 0
  },
  rtmp: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['rtmp'],
    total: 0
  },
  producer: {
    hasNextPage: false,
    rid: '',
    condition: '',
    origin: 6,
    pageNum: 1,
    pageSize: 12,
    queryList: ['producer'],
    total: 0
  }
}
export const RMessage = {
  StartUpDateTime: '2022-01-18T11:43:21.6537237Z',
  IsExiting: false,
  WorkMode: 0,
  SubMode: 0,
  CurrentTId: 0,
  CurrentTStrId: '',
  CurrentTStrIdHex: '',
  CurrentTStr0xId: '',
  CurrentTStr0xIdHex: '',
  CurrentTStr0xIdHexDashName: '',
  CurrentTName: '',
  CurrentBitrate: 4096,
  CurrentTBitrateConfig: 4096,
  CurrentTDelay: 2000,
  CurrentTType: 0,
  CurrentTInputType: {
    Name: 'NA',
    ReadableName: 'N/A',
    TVUName: 'N/A',
    IsSupported: false
  },
  CurrentTFormat: { Name: 'NA', ReadableName: 'N/A', Width: 720, Height: 486 },
  CurrentTVersion: '0.0.0.0build0',
  CurrentTPeerVersion: { Major: 0, Minor: 0, Revision: 0, Beta: 0, Build: 0 },
  CurrentTVideoMode: 0,
  CurrentTStatus: 0,
  CurrentOutputFormat2: {
    Name: '1080I5994',
    ReadableName: '1080i59.94',
    Width: 1920,
    Height: 1080
  },
  CurrentAspect: 1,
  CurrentSD: 1,
  IsCurrentOutputSD: false,
  IsCurrentOutputHD: true,
  IsCurrentOutputHD720P: false,
  IsCurrentOutputHD1080I: true,
  IsCurrentOutput4KUHD1: false,
  IsCurrentOutput4KDCI: false,
  CurrentOutputFramerateInt: 30,
  CurrentTPackBatteryRaw: { BAT1: '', BAT2: '', BAT1VAL: '', BAT2VAL: '' },
  CurrentTLiveId: 0,
  WaitingSeconds: -1,
  IsLive: false,
  IsPreview: false,
  StoryId: '',
  AIDelay: 6,
  SelectedPeerStatus: 5,
  WebRM3U8PlaybackUrl: '',
  WebRSDIFeedUrl: '',
  WebRM3U8D: 1.0,
  WebRVideoSolution: 300,
  CurrentTimestamp: '05:30:05',
  IsBtnLiveEnabled: false,
  LibCoreLastErrorMessage: '',
  RVFPackUrl: null,
  RVFSdiUrl: null,
  RVFPackOn: false,
  RVFSdiOn: false,
  PackDisplayOutUrl: null,
  LocalSDIDisplayOutUrl: null
}
export const SourceConfigParams = (programId, bucketCode) => {
  const AllConfigParams = {
    Live: {
      url: '/device/pageSourceDevice',
      Params: {
        pageNum: 0,
        pageSize: 10,
        totalNum: 1,
        condition: '',
        programId
      },
      List: []
    },
    Media: {
      url: '/playoutfolderNew/pageMedia',
      Params: {
        pageNum: 0,
        pageSize: 10,
        totalNum: 1,
        bucketCode,
        programId,
        searchType: 1
      },
      List: []
    },
    AmazonS3: {
      url: '/playoutfolderNew/pageExternalMedia',
      Params: {
        pageNum: 0,
        pageSize: 10,
        totalNum: 1,
        programId
      },
      List: []
    },
    search: {
      url: '/source/page',
      Params: {
        pageNum: 0,
        pageSize: 10,
        totalNum: 1,
        condition: '',
        bucketCode,
        programId
      }
    }
  }
  return JSON.parse(JSON.stringify(AllConfigParams))
}
export const keyLogVolue = {
  description: 'lang.des',
  startTime: 'lang.startTime',
  endTime: 'lang.endTime',
  color: 'lang.color',
  houseId: 'lang.houseIdTitle',
  record: 'lang.SecondaryRecord',
  replay: 'lang.Replay',
  category: 'lang.Category',
  recurType: 'lang.Event',
  season: 'lang.Season',
  episode: 'lang.Episode1',
  series: 'lang.Series',
  episodeTitle: 'lang.EpisodeTitle',
  thumbnail: 'lang.ThumbnailURL',
  pgmEndScte: 'lang.SCTEPGMEnd',
  pgmStartScte: 'lang.SCTEPGMStart',
  multipleModelType: 'lang.followLastEvent',
  tname: 'lang.PrimarySource',
  secondaryTname: 'lang.SecondarySource',
  bitrate: 'lang.bitrate',
  reporter: 'lang.reporter',
  occasionalOutputMessage: 'lang.occasionalOutput',
  eventModelType: 'lang.Event'
}
export default {
  Segments,
  LogoConfig,
  ScteType,
  UnderplayType,
  SourceClassifyConfig,
  InquireSourceParam,
  RMessage,
  SourceConfigParams
}
